import { useQuery } from '@tanstack/react-query';
import { routeSchedulesGetRouteSchedule } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useRouteSchedules = (routeId: number) =>
  useQuery({
    queryFn: () =>
      extractData(routeSchedulesGetRouteSchedule({ path: { routeId } })),
    queryKey: ['RouteSchedules', routeId],
  });
